import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import Config, { PaginationLimit } from "../../Config";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import {
  PrevBtn,
  NextBtn,
  PaginationWrapper,
  MenuOptions,
  MenuItem,
  Btn,
} from "../Styles/PageStyles";
import { IoMdMore } from "react-icons/io";
import { FaLink } from "react-icons/fa";
import { MdHistory } from "react-icons/md";
import { FaFemale, FaMale } from "react-icons/fa";
import { RiUserSettingsFill } from "react-icons/ri";
import { FiEdit3 } from "react-icons/fi";
import {
  capitalizeFirstLetter,
  getRole,
  handleCopy,
  truncateText,
} from "../../helpers";
import moment from "moment";
import { ImUserCheck } from "react-icons/im";
import { useNavigate } from "react-router-dom";
import { FaCirclePlus } from "react-icons/fa6";
import { IoCopySharp } from "react-icons/io5";
import Tooltip from "../Tooltip";

const Tables = ({
  apiData,
  setSelectedData,
  setIsStaffAttendance,
  attendanceFlag,
  setIsEditStaff,
  setLinkStaff,
  setIsStaffSummary,
  setStaffPermission,
  setLocationModel,
  openLogs,
  user,
  activeTab,
  canManageStaffPermissions
}) => {

  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [currentPage, setCurrentPage] = useState(0);
  useEffect(() => {
    setCurrentPage(0);
  }, [activeTab]);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const [previousId, setPreviousId] = useState(null);
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);

  const navigate = useNavigate();

  const edit = (item) => {
    setIsEditStaff(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const linkUnlink = (item) => {
    setLinkStaff(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const staffPermissionSetting = (item) => {
    setStaffPermission(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const addLocation = (item) => {
    setLocationModel(true);
    setSelectedData(item);
  };

  const staffAttendance = (item) => {
    navigate(`/staff/attendance/${item.id}`, {
      state: { staffName: item.name },
    });
  };
  const staffSummary = (item) => {
    setIsStaffSummary(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const ActionBtns = (item) => {
    const openMenu = (id) => {
      setPreviousId(openActionMenu);
      setOpenActionMenu((prevId) => {
        return prevId === id ? null : id;
      });
    };

    return (
      <ActionBtnWrapper>
        {openActionMenu === item.id && (
          <MenuOptions id="menuOptions">
            {item.status === 1 && (
              <MenuItem
                onClick={() => {
                  linkUnlink(item);
                }}
              >
                <FaLink className="text-gray-700 " /> Link - Unlink
              </MenuItem>
            )}
            {canManageStaffPermissions && (
              <MenuItem
                title="Staff Settings"
                onClick={() => {
                  staffPermissionSetting(item);
                }}
              >
                <RiUserSettingsFill className="text-gray-700 " /> Permissions
              </MenuItem>
            )}
            {attendanceFlag === 1 && item.role !== 7 && (
              <MenuItem
                title="Staff Attendance"
                onClick={() => staffAttendance(item)}
              >
                <ImUserCheck className="text-gray-700 " /> Attendance
              </MenuItem>
            )}

            <MenuItem
              title={
                item.reportingLatitude && item.reportingLongitude
                  ? "Edit Location"
                  : "Add Location"
              }
              onClick={() => {
                addLocation(item);
              }}
            >
              {item.reportingLatitude && item.reportingLongitude ? (
                <>
                  <FiEdit3 className="text-gray-700" /> Edit Location
                </>
              ) : (
                <>
                  <FaCirclePlus className="text-gray-700" /> Add Location
                </>
              )}
            </MenuItem>
          </MenuOptions>
        )}
        <Btn title="Actions" type="button" onClick={() => openMenu(item.id)}>
          <IoMdMore className="text-gray-600" size={24} />
        </Btn>
      </ActionBtnWrapper>
    );
  };

  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };
  const [selectedRow, setSelectedRow] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getName = (item) => {
    const name = capitalizeFirstLetter(item?.name);

    return (
      <div
        className={`flex items-center gap-3 ${user?.userType === 3 && user?.role !== Config.STAFF_ROLES.SALES_HEAD && user?.role !== Config.STAFF_ROLES.PARTNER ? "cursor-default" : "cursor-pointer"
          }`}
        onClick={() => {
          if (
            user?.userType === 3 &&
            user?.role !== Config.STAFF_ROLES.SALES_HEAD &&
            user?.role !== Config.STAFF_ROLES.PARTNER
          ) return;

          navigate("/staff-detail", {
            state: { staffDetails: item },
          });
        }}
      >
        <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center">
          {item.gender === 1 ? (
            <FaMale className="text-blue-500" />
          ) : (
            <FaFemale className="text-pink-500" />
          )}
        </div>

        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <span className="font-medium text-gray-600 truncate max-w-[140px]">
              {truncateText(name, 25)}
            </span>

            <span
              className={`w-2 h-2 rounded-full ${item.status === 1 ? "bg-green-500" : "bg-gray-300"
                }`}
            />
          </div>

          <div className="flex items-center gap-1 text-xs text-gray-400">
            #{item.mobile}
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleCopy(item.mobile);
              }}
              className="hover:text-gray-600 transition"
              title="Copy number"
            >
              <IoCopySharp size={12} />
            </button>
          </div>
        </div>
      </div>
    );
  };

  const ActivitiesBtns = (item) => {
    return (
      <div className="flex gap-4 ">
        <button
          onClick={() => openLogs(item)}
          className={`cursor-pointer text-sm px-4 py-1 rounded-lg flex items-center gap-1`}
        >
          <MdHistory className="text-gray-400" size={20} />
        </button>
      </div>
    );
  };
  const getDisplayRole = (item) => {
    if (Number(item?.role) === Config.STAFF_ROLES.ADMIN && Number(item?.isSuperAdmin) === 1) {
      return "Super Admin";
    }
    return getRole(item.role);
  };
  useEffect(() => {
    if (apiData) {
      const tempData = apiData.map((item) => ({
        name: getName(item),
        checkIn: getTime(item),
        createdAt: item?.lastLogin
          ? getLastLogin(item?.lastLogin)
          : getLastLogin(item.createdAt),
        salary: item?.salary ? "₹" + item.salary : "N/A",
        attendanceStatus: getAttendanceStatus(item),
        mobile: (
          <span className="text-gray-600 text-sm">{"#" + item.mobile}</span>
        ),
        role: (
          <span className="text-xs px-2 py-1 rounded-md border border-gray-200 text-gray-600 bg-gray-50">
            {getDisplayRole(item)}
          </span>
        ),
        activities: ActivitiesBtns(item),
        action: ActionBtns(item),
      }));
      setData(tempData);
    }
  }, [apiData, openActionMenu]);

  const getAttendanceStatus = (item) => {
    if (item.attendance === 1) {
      return (
        <p className="bg-green-50 text-green-700 text-xs border-green-100 border w-24 h-7 flex items-center justify-center rounded-lg">
          Present
        </p>
      );
    } else {
      return (
        <p className="bg-rose-50 text-rose-700 text-xs border-rose-100 border w-24 h-7 flex items-center justify-center rounded-lg">
          Absent
        </p>
      );
    }
  };

  const getLoginTimeColor = (lastLogin) => {
    if (!lastLogin) return "#9CA3AF";

    const days = moment().diff(moment(lastLogin), "days");

    if (days <= 1) return "bg-green-50";
    if (days <= 3) return "bg-yellow-50";
    if (days <= 7) return "bg-orange-50";

    return "bg-rose-50";
  };

  const getLastLogin = (lastLogin) => {
    const bg = getLoginTimeColor(lastLogin);

    return (
      <Tooltip label={`Last login: ${moment(lastLogin).fromNow()}`}>
        <span className={`${bg} px-3 py-1 rounded-md text-xs text-gray-700`}>
          {moment(lastLogin).format("DD MMM, hh:mm A")}
        </span>
      </Tooltip>
    );
  };

  const getTime = (item) => {
    return (
      <div>
        {item.attendanceTime ? (
          <div className="flex gap-1 flex-col">
            <span className="text-gray-600 text-sm">
              {moment(item.attendanceTime, "HH:mm:ss").format("hh:mm A")}
            </span>
            <span className="text-gray-400 text-xs">{item.propName}</span>
          </div>
        ) : (
          <span className="text-gray-600 text-sm">-</span>
        )}
      </div>
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const columns = useMemo(() => {
    const isSalesHead = user?.role === Config.STAFF_ROLES.SALES_HEAD;

    if (isMobileView) {
      if (isSalesHead) {
        return [
          {
            Header: "Name",
            accessor: "name",
          },
        ];
      }

      return [
        {
          Header: "Name",
          accessor: "name",
        },
        {
          Header: "Role",
          accessor: "role",
        },
      ];
    }

    if (isSalesHead) {
      return [
        {
          Header: "Name",
          accessor: "name",
        },
        {
          Header: "Salary",
          accessor: "salary",
        },
        {
          Header: "Activities",
          accessor: "activities",
        },
        {
          Header: "Last Login",
          accessor: "createdAt",
        },
        {
          Header: "Action",
          accessor: "action",
        },
      ];
    }

    return [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Role",
        accessor: "role",
      },
      {
        Header: "Salary",
        accessor: "salary",
      },
      {
        Header: "Activities",
        accessor: "activities",
      },
      {
        Header: "Last Login",
        accessor: "createdAt",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ];
  }, [isMobileView, user?.role]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex, pageSize },
    previousPage,
    nextPage,
    setPageSize,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination,
  );
  useEffect(() => {
    setCurrentPage(pageIndex);
  }, [pageIndex]);
  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                          } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody
          {...getTableBodyProps()}
          hasdata={(apiData?.length > 0).toString()}
        >
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr
                  {...row.getRowProps({ style: { height: "80px" } })}
                  hasdata={(apiData?.length > 0).toString()}
                >
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        {user?.role !== Config.STAFF_ROLES.SALES_HEAD && (
                          <li>
                            <strong>Role:</strong> {data[rowIndex]?.role}
                          </li>
                        )}
                        <li className="flex gap-2">
                          <strong>Attendance Status:</strong>{" "}
                          {data[rowIndex]?.attendanceStatus}
                        </li>
                        <li className="flex gap-2">
                          <strong>Check In:</strong> {data[rowIndex]?.checkIn}
                        </li>
                        <li>
                          <strong>Action:</strong> {data[rowIndex]?.action}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {apiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>
          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75 "
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};
const UserImageWrapper = tw.div` flex items-center gap-2`;

const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const ActionBtnWrapper = tw.div`flex items-center gap-1 relative`;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`
  border-b
  hover:bg-slate-50
  transition
`;
export default Tables;